import { ModuleName, ModuleNamePerceptionBar, ModuleNameScreenReader } from '../enums/enums'
import { Module } from '../models/global.types'

export function parseModuleName (name: string | null): ModuleName | null {
  if (name === null) {
    return null
  }

  switch (name.toLowerCase()) {
    case ModuleName.Cocaine.toLowerCase():
      return ModuleName.Cocaine
    case ModuleName.Xanax.toLowerCase():
      return ModuleName.Xanax
    case ModuleName.Mdma.toLowerCase():
      return ModuleName.Mdma
    case ModuleName.Response.toLowerCase():
      return ModuleName.Response
    case ModuleName.Lightning.toLowerCase():
      return ModuleName.Lightning
    default:
      return null
  }
}

export function getModuleNamePerceptionBar (name: ModuleName | null): ModuleNamePerceptionBar | null {
  if (name === null) {
    return null
  }

  switch (name) {
    case ModuleName.Cocaine:
      return ModuleNamePerceptionBar.Cocaine
    case ModuleName.Xanax:
      return ModuleNamePerceptionBar.Xanax
    case ModuleName.Mdma:
      return ModuleNamePerceptionBar.Mdma
    case ModuleName.Response:
      return ModuleNamePerceptionBar.Response
    case ModuleName.Lightning:
      return ModuleNamePerceptionBar.Lightning
  }
}

export function getModuleNameScreenReader (name: ModuleName | null): ModuleNameScreenReader | null {
  if (name === null) {
    return null
  }

  switch (name) {
    case ModuleName.Cocaine:
      return ModuleNameScreenReader.Cocaine
    case ModuleName.Xanax:
      return ModuleNameScreenReader.Xanax
    case ModuleName.Mdma:
      return ModuleNameScreenReader.Mdma
    case ModuleName.Response:
      return ModuleNameScreenReader.Response
    case ModuleName.Lightning:
      return ModuleNameScreenReader.Lightning
  }
}

/**
 * Get the level (sort order) for a given module based on dynamic backend data.
 * This replaces the hardcoded module levels to support arbitrary module ordering.
 *
 * @param moduleName The module name to get the level for
 * @param modules Array of modules from backend with sort order
 * @returns The level (sort order) of the module, defaults to 1 if not found
 */
export function getModuleLevel (moduleName: ModuleName | null, modules: Module[] = []): number {
  const defaultLevel = 1

  if (moduleName === null || modules.length === 0) {
    return defaultLevel
  }

  // Find the module by name (case insensitive comparison)
  const module = modules.find(m =>
    m.name.toLowerCase() === moduleName.toLowerCase()
  )

  if (module === undefined) {
    return defaultLevel
  }

  return module.sort !== undefined && module.sort !== null ? module.sort : defaultLevel
}
